import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

import Survey from '../../reusable_components/Survey';
import { QUESTION_NAME, SURVEY_SLUG } from '../../reusable_components/Survey/enums';
import TooltipTarget from '../../reusable_components/TooltipTarget';
import { angry, happy, love, neutral, sad } from '../../reusable_components/icons/rating_svgs';

import layout from '../../../styles/global_ui/layout';
import typography from '../../../styles/global_ui/typography';
import surveyStyle from '../../reusable_components/Survey/popover.css';
import style from './style.css';

const VERSION = 1.0;

const surveyJson = {
  title: SURVEY_SLUG.PASSIVE_GENERAL_FEEDBACK,
  version: VERSION,
  showTitle: false,
  showQuestionNumbers: false,
  completeText: 'Submit',
  pagePrevText: '< Back',
  completedHtmlOnCondition: [
    {
      expression: `{${QUESTION_NAME.FEELING}} == 1`,
      html: `<h4>Thank you!<span>Your feedback was received.</span></h4><div>${angry}</div><p>{feedback}</p>`,
    },
    {
      expression: `{${QUESTION_NAME.FEELING}} == 2`,
      html: `<h4>Thank you!<span>Your feedback was received.</span></h4><div>${sad}</div><p>{feedback}</p>`,
    },
    {
      expression: `{${QUESTION_NAME.FEELING}} == 3`,
      html: `<h4>Thank you!<span>Your feedback was received.</span></h4><div>${neutral}</div><p>{feedback}</p>`,
    },
    {
      expression: `{${QUESTION_NAME.FEELING}} == 4`,
      html: `<h4>Thank you!<span>Your feedback was received.</span></h4><div>${happy}</div><p>{feedback}</p>`,
    },
    {
      expression: `{${QUESTION_NAME.FEELING}} == 5`,
      html: `<h4>Thank you!<span>Your feedback was received.</span></h4><div>${love}</div><p>{feedback}</p>`,
    },
  ],
  pages: [
    {
      name: 'Feeling and Comment',
      title: 'Help us improve Hackster!',
      questions: [
        {
          type: 'rating',
          name: `${QUESTION_NAME.FEELING}`,
          title: 'How was your recent experience with Hackster?',
          itemComponent: 'RobotRating',
          rateCount: 5,
          rateMax: 5,
          displayMode: 'buttons', // this forces options to be inline on one row.
          isRequired: true,
          errorLocation: 'bottom',
        },
        {
          type: 'comment',
          name: `${QUESTION_NAME.FEEDBACK}`,
          title: 'Feedback',
          isRequired: true,
          rows: 4,
          width: '100%',
          errorLocation: 'bottom',
        },
      ],
    },
  ],
};

const c = {
  container: `${layout.flexColumn} ${layout.gutter10} ${surveyStyle.container}`,
  title: `${typography.textCenter} ${typography.h3Responsive} ${typography.charcoal}`,
};

const customCss = {
  completedPage: c.container,
  page: { title: c.title },
  // this resets the question title to match our other surveys.
  question: { header: '' },
  rating: { root: style.list },
};

const FeedbackSurvey = ({ align, alignOffset, sideOffset }) => {
  const [showTip, setShowTip] = useState(true);

  const onOpenChange = useCallback((isOpening) => {
    setShowTip(!isOpening);
  }, [setShowTip]);

  return (
    <TooltipTarget
      classList={{ tooltipInner: typography.lineHeight1 }}
      offsetY={6}
      tooltip={showTip ? 'Leave Feedback' : null}
    >
      <Survey
        align={align}
        alignOffset={alignOffset}
        element="popup"
        onOpenChange={onOpenChange}
        sideOffset={sideOffset}
        surveyCss={customCss}
        surveyJson={surveyJson}
        surveySlug={SURVEY_SLUG.PASSIVE_GENERAL_FEEDBACK}
        triggerIconName="chat-outline"
        triggerTitle="Leave Feedback"
        version={VERSION}
      />
    </TooltipTarget>
  );
};

export default FeedbackSurvey;

FeedbackSurvey.propTypes = {
  align: PropTypes.string,
  alignOffset: PropTypes.number,
  sideOffset: PropTypes.number,
};
